import type { State } from '@/reducers/types';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { retrievePtal } from './actions';

const ptalsAdapter = createEntityAdapter<any>({
  sortComparer: (a, b) => a.id.localeCompare(b.id),
});

interface PtalsState {
  total: number;
  ptalData: any;
  isRegenerated?: boolean;
  title?: string;
}

const initialState = ptalsAdapter.getInitialState<PtalsState>({
  total: 0,
  ptalData: null,
  isRegenerated: undefined,
  title: undefined,
});

const { name, reducer, actions } = createSlice({
  name: 'ptals',
  initialState,
  reducers: {
    setPtalData(state, action) {
      state.ptalData = action.payload;
    },
    setIsRegenerated(state, action) {
      state.isRegenerated = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(retrievePtal.fulfilled, (state, action) => {
      if (action.payload && action.payload.type === 'complete') {
        const completeUpdate = action.payload.updates.find(
          (update: any) => update.type === 'chain-success',
        );
        state.ptalData = completeUpdate?.output?.output.answer;
      }
    });
  },
});

const { setPtalData, setIsRegenerated, setTitle } = actions;

export { name, reducer, setIsRegenerated, setPtalData, setTitle };

export const selectPtalData = (state: State) => state[name].ptalData;
export const selectPtalIsRegenerated = (state: State) => state[name].isRegenerated;
export const selectPtalTitle = (state: State) => state[name].title;
